import styled from 'styled-components';

export const HintStyled = styled.p`
  margin: 0;
  padding: 6px 12px;
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  font-size: 12px;
`;
